import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  cellularData: null,
  loading: false,
  error: false,
};

const setCellular = (state, action) => {
  return updateObject(state, { cellularData: action.cellularData, loading: false, error: false });
};

const fetchCellularFailed = (state) => {
  return updateObject(state, { error: true, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_CELLULAR: return updateObject(state, { loading: true });
    case actionTypes.SET_CELLULAR: return setCellular(state, action);
    case actionTypes.FETCH_CELLULAR_FAILED: return fetchCellularFailed(state);
    default: return state;
  }
};

export default reducer;
